"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaidParking = function PaidParking(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 64 64", className: "custom-icon" }, props),
    _react2.default.createElement(
      "g",
      { id: "Car_park", "data-name": "Car park" },
      _react2.default.createElement("path", { d: "M27,47a3,3,0,1,0,3,3A3,3,0,0,0,27,47Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,27,51Z" }),
      _react2.default.createElement("path", { d: "M51,47a3,3,0,1,0,3,3A3,3,0,0,0,51,47Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,51,51Z" }),
      _react2.default.createElement("path", { d: "M59,35H56.734a3.011,3.011,0,0,0-2.669,1.652A11.053,11.053,0,0,0,43.327,28H34.673a11.053,11.053,0,0,0-10.738,8.652A3.011,3.011,0,0,0,21.266,35H19a3,3,0,0,0-3,3v1a3,3,0,0,0,3,3h1.586l.585.585a5,5,0,0,0-2.651,3.707l-.857,6A4.994,4.994,0,0,0,22,57.959V59a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3V58H46v1a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3V57.959a4.994,4.994,0,0,0,4.337-5.667l-.857-6a5,5,0,0,0-2.651-3.707L57.414,42H59a3,3,0,0,0,3-3V38A3,3,0,0,0,59,35ZM25.763,37.728A9.045,9.045,0,0,1,34.673,30h8.654a9.045,9.045,0,0,1,8.91,7.728L52.847,42H25.153ZM19,40a1,1,0,0,1-1-1V38a1,1,0,0,1,1-1h2.266a1,1,0,0,1,.989.859l.5,3.479-1.045-1.045A1,1,0,0,0,21,40ZM30,59a1,1,0,0,1-1,1H25a1,1,0,0,1-1-1V58h6Zm24,0a1,1,0,0,1-1,1H49a1,1,0,0,1-1-1V58h6Zm4.358-6.424A3,3,0,0,1,55.388,56H22.612a3,3,0,0,1-2.97-3.424l.857-6A3.015,3.015,0,0,1,23.469,44H54.531a3.015,3.015,0,0,1,2.97,2.576ZM60,39a1,1,0,0,1-1,1H57a1,1,0,0,0-.707.293l-1.045,1.045.5-3.48A1,1,0,0,1,56.734,37H59a1,1,0,0,1,1,1Z" }),
      _react2.default.createElement("path", { d: "M45,48H33a1,1,0,0,0-.949,1.316l1,3A1,1,0,0,0,34,53H44a1,1,0,0,0,.949-.684l1-3A1,1,0,0,0,45,48Zm-1.721,3H34.721l-.334-1h9.226Z" }),
      _react2.default.createElement("path", { d: "M13,53.184V26h6a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V25a1,1,0,0,0,1,1H8V53.184A3,3,0,0,0,6,56v5a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V56A3,3,0,0,0,13,53.184ZM4,8H18V24H4Zm7,18V53H10V26Zm2,34H8V56a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1Z" }),
      _react2.default.createElement("path", { d: "M10,21V18h2a4,4,0,0,0,0-8H9a1,1,0,0,0-1,1V21a1,1,0,0,0,2,0Zm0-9h2a2,2,0,0,1,0,4H10Z" }),
      _react2.default.createElement("path", { d: "M34.707,32.293a1,1,0,0,0-1.414,0l-5,5a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,34.707,32.293Z" }),
      _react2.default.createElement("path", { d: "M38.293,32.293l-5,5a1,1,0,1,0,1.414,1.414l5-5a1,1,0,0,0-1.414-1.414Z" })
    )
  );
};

exports.default = PaidParking;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/paidparking.js
// module id = 1928
// module chunks = 1143